import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCase } from '../../lib/callables';

export function useCreateCase() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCase,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['cases'] });
    },
  });
}
